import * as tslib_1 from "tslib";
import { Logger } from '@services/logger/abstract.logger';
import { NonPublicallyNullableStateManager } from 'main/app-state/generics/state-manager';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthConfigService } from './auth-config.service';
var AuthConfigManager = /** @class */ (function (_super) {
    tslib_1.__extends(AuthConfigManager, _super);
    function AuthConfigManager(injector) {
        var _this = _super.call(this) || this;
        _this._state = new BehaviorSubject(null);
        _this._authConfigService = injector.get(AuthConfigService);
        // The Injector doesn't work directly with abstract classes, so manual casting to Type<Logger> has to be done.
        // More details: https://github.com/angular/angular/issues/23611
        _this._logStateChanges('Auth Config', injector.get(Logger));
        return _this;
    }
    AuthConfigManager.prototype.fetch = function () {
        var _this = this;
        return this._authConfigService.get()
            .pipe(tap(function (data) { return _this._state.next(data); }));
    };
    Object.defineProperty(AuthConfigManager.prototype, "buildVersion", {
        get: function () {
            return this.value.serverSettings.build.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthConfigManager.prototype, "odataBaseUrl", {
        get: function () {
            return "odata";
        },
        enumerable: true,
        configurable: true
    });
    return AuthConfigManager;
}(NonPublicallyNullableStateManager));
export { AuthConfigManager };
